import { useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "@/styles/ag-grid-theme.css";
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  AllCommunityModule,
} from "ag-grid-community";

// Alpine theme is no longer needed as we're using our custom theme
import { useTheme } from "next-themes";

ModuleRegistry.registerModules([AllCommunityModule, ClientSideRowModelModule]);

export interface GridContainerProps {
  children: React.ReactElement;
  cssContainer?: string;
}

export const GridContainer = (props: GridContainerProps) => {
  const { theme, resolvedTheme } = useTheme();
  const isDark = theme === "dark" || resolvedTheme === "dark";

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);

  const cssClassNames = useMemo(() => {
    if (props.cssContainer) {
      return `${props.cssContainer} wb-ag-theme ${
        isDark ? "dark" : ""
      } animate-in fade-in duration-300`;
    }
    return `wb-ag-theme ${
      isDark ? "dark" : ""
    } animate-in fade-in duration-300`;
  }, [props.cssContainer, isDark]);

  return (
    <div
      className={cssClassNames}
      style={containerStyle}
      data-theme={isDark ? "dark" : "light"}
    >
      {props.children}
    </div>
  );
};
